var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"rogue-wrapper"},[_c(_vm.rougeContainer,_vm._g(_vm._b({tag:"component"},'component',{ ..._vm.$attrs, ..._vm.$props },false),_vm.$listeners),[_c('template',{slot:"slot"},[_vm._t("default")],2)],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }